var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnAuthorFeedbackIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M111.664 51.247h-6.901c4.494-6.882 3.722-16.197-2.321-22.239-6.93-6.93-18.166-6.93-25.097 0l-1.59 1.59v-8.663C75.755 9.82 65.935 0 53.821 0 41.706 0 31.886 9.82 31.886 21.935v9.516h-3.653C12.64 31.451 0 44.091 0 59.684s12.64 28.234 28.233 28.234h83.431c10.127 0 18.336-8.21 18.336-18.336 0-10.126-8.209-18.335-18.336-18.335z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.664 51.247h-6.901c4.494-6.881 3.722-16.196-2.321-22.239-6.93-6.93-18.166-6.93-25.097 0l-1.59 1.59v-8.663c0-12.06-9.733-21.842-21.77-21.93v87.913h57.679c10.127 0 18.336-8.21 18.336-18.336 0-10.126-8.209-18.335-18.336-18.335z",
    fill: "#EAEAEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.198 48.832a13.41 13.41 0 00-1.358-.076c-4.698 0-8.905 2.43-11.254 6.498L5.797 106.85c-2.348 4.068-2.348 8.926 0 12.995 2.35 4.068 6.557 6.497 11.254 6.497h31.147v-77.51z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.883 106.85L58.094 55.254c-2.349-4.069-6.556-6.498-11.254-6.498v77.586h29.79c4.697 0 8.904-2.429 11.253-6.497 2.35-4.069 2.35-8.927 0-12.995z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.695 122.371H14.243a6.524 6.524 0 01-5.708-3.296 6.524 6.524 0 010-6.591l32.597-56.46a6.524 6.524 0 015.708-3.296c.29 0 .574.019.855.054v-7.657a14.686 14.686 0 00-.855-.026c-5.14 0-9.744 2.658-12.315 7.11L1.928 108.67c-2.57 4.452-2.57 9.768 0 14.22S9.102 130 14.243 130h33.452v-7.629z",
    fill: "#E43B54"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.753 108.67L59.155 52.209c-2.57-4.452-7.174-7.11-12.315-7.11v7.629a6.524 6.524 0 015.708 3.295l32.598 56.461a6.524 6.524 0 010 6.591 6.524 6.524 0 01-5.708 3.296H46.84V130h32.598c5.14 0 9.745-2.658 12.315-7.11 2.57-4.452 2.57-9.768 0-14.22z",
    fill: "#ED1B2E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.884 98.484V75.933h-4.633l1.53 22.551h3.103zM46.884 104.275l-.043-.002c-2.764 0-4.738 1.875-4.738 4.392 0 2.467 1.974 4.491 4.738 4.491l.043-.002v-8.879z",
    fill: "#ED1B2E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.43 75.933h-4.59v22.551h3.06l1.53-22.551zM51.578 108.665c0-2.517-1.974-4.392-4.737-4.392v8.883c2.763 0 4.737-2.024 4.737-4.491z",
    fill: "#ED1B2E"
  })));
}

export default SvgUnAuthorFeedbackIcon;